import { lookupNestedProp, NumberCol, sortStringInner, StringCol, Table, useTableRefresher, ViewOnly } from "../../../misc/scroller/Table";
import { removeRowOption, RowOptionCol } from "../purchasing/RowOptions";
import { RestockStatus } from "./Restocking";
import { getAll } from "../routes/useGetAll";
import { api } from "../../../api/API";
import { CreateStockingFrameProduct } from "./CreateStockingFrameProduct";
import { ViewReservations } from "./reservations/ViewReservations";
import { orderByAscending } from "nate-react-api-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
export function inventoryTableName(tab2, kind) { return "inventory." + tab2 + "." + kind; }
export function InventoryFrameTable(props) { const tab2 = props.tab; const search = props.search; const tableName = inventoryTableName(tab2, "frame"); const tblRefresh = useTableRefresher(tableName); return /*#__PURE__*/ _jsx(Table, { name: tableName, columns: [RowOptionCol({ options: dt => [{ name: "View Reservations", onClick: ctx => { ctx.display(onClose => { return /*#__PURE__*/ _jsx(ViewReservations, { value: dt, onClose: () => { onClose(); tblRefresh(); } }); }); ctx.onClose(); } }, removeRowOption(dt, { refreshTables: [tableName], confirm: false })] }), ViewOnly(NumberCol("Ref", "id", 60)), ViewOnly(StringCol("Mfg", "manufacturerName", 100)), ViewOnly(Object.assign(StringCol("Description", "name", 100), { render: dt => { return dt.name; } })), ViewOnly(StringCol("Series", "frame.series", 150)), ViewOnly(StringCol("Material", "frame.material")), ViewOnly(StringCol("Gauge", "frame.gauge")), ViewOnly(StringCol("Screen Elev", "frame.screenElev")), ViewOnly(StringCol("Profile", "frame.profile")), ViewOnly(StringCol("Jamb Depth", "frame.jambDepth")), ViewOnly(StringCol("Door Thickness", "frame.doorThickness")), ViewOnly(StringCol("Construction", "frame.construction")), ViewOnly(StringCol("Handing", "frame.handing")), ViewOnly(StringCol("Label", "frame.label")), ViewOnly(StringCol("Type", "frame.type")), ViewOnly(StringCol("Height", "frame.height")), ViewOnly(StringCol("Width", "frame.width")), ViewOnly(PrepsCol("frame.preps")), RestockStatus(), ViewOnly(NumberCol("Avail.", "availableQty", 40)), ViewOnly(NumberCol("Resrv.", "reservedQty", 60)), ViewOnly(NumberCol("Shelf", "qty", 60)), ViewOnly(NumberCol("Pending Po", "pendingPoQty", 60)), Object.assign(NumberCol("Min Qty", "stockMinQty", 40), { render: v => v.isStocking ? v.stockMinQty.toString() : "" }), Object.assign(NumberCol("Ideal Qty", "idealQty", 40), { render: v => v.isStocking ? v.idealQty.toString() : "" })], fetch: ctx => getAll(ctx, offset => api.logistics.listInventory({ offset, search, kind: tab2, subKind: "frame" })), fetchDeps: [search, tab2], onChange: value => api.logistics.updateInventory(value), insert: props.tab === "stocking" ? { buttonText: "New Row", alignX: "left", modal: input => /*#__PURE__*/ _jsx(CreateStockingFrameProduct, { onDone: input }) } : undefined }, "inventory." + tab2 + ".frame"); }
export function PrepsCol(key) { let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Preps"; return { name: name, width: 100, render: v => { const p = lookupNestedProp(v, key); return prepsAsString(p); }, sort: (a, b) => sortStringInner(prepsAsString(lookupNestedProp(a, key)), prepsAsString(lookupNestedProp(b, key))), filter: (v, search) => { return prepsAsString(lookupNestedProp(v, key)).toLowerCase().includes(search.toLowerCase()); } }; }
export function getSpecialtyHingePrepLocation(preps) { const keys = Object.keys(preps); const withDoorLocation = []; const withFrameInActive = []; const withFrameActive = []; for (let k of keys) {
    const obj = preps[k];
    if (obj.type === "custom" || obj.type === "standard") {
        if (obj.hingeDoorIndexes) {
            withDoorLocation.push({ indexes: obj.hingeDoorIndexes });
        }
        if (obj.hingeFrameInActiveIndexes) {
            withFrameInActive.push({ indexes: obj.hingeFrameInActiveIndexes });
        }
        if (obj.hingeFrameActiveIndexes) {
            withFrameActive.push({ indexes: obj.hingeFrameActiveIndexes });
        }
    }
} if (withDoorLocation.length > 0) {
    return formatHingeLocationIndexes(withDoorLocation);
} if (withFrameActive.length > 0 || withFrameInActive.length > 0) {
    if (withFrameActive.length > 0 && withFrameInActive.length > 0) {
        const active = formatHingeLocationIndexes(withFrameActive);
        const inActive = formatHingeLocationIndexes(withFrameInActive);
        return { display: `${active.display} (Active), ${inActive.display} (Inactive)` };
    }
    if (withFrameActive.length > 0) {
        const active = formatHingeLocationIndexes(withFrameActive);
        return { display: `${active.display} (Active)` };
    }
    if (withFrameInActive.length > 0) {
        const inActive = formatHingeLocationIndexes(withFrameInActive);
        return { display: `${inActive.display} (Inactive)` };
    }
} return null; }
export function formatHingeLocationIndexes(input) { orderByAscending(input, i => i.indexes.length); const specials = input.slice(0, input.length - 1); const indexes = mergeIndexes(specials.map(s => s.indexes)); if (indexes.length === 1) {
    return { display: formatIndexes(indexes) };
} return { display: formatIndexes(indexes) }; }
export function formatIndexes(input) { if (input.length === 1) {
    const i = input[0];
    return i === 0 ? "Top" : `${withOrdinal(i + 1)} from Top`;
} orderByAscending(input, i => i); return input.map(i => i === 0 ? "Top" : `${withOrdinal(i + 1)}`).join(", ") + " from Top"; }
function withOrdinal(i) { let j = i % 10, k = i % 100; if (j === 1 && k !== 11) {
    return i + "st";
} if (j === 2 && k !== 12) {
    return i + "nd";
} if (j === 3 && k !== 13) {
    return i + "rd";
} return i + "th"; }
function mergeIndexes(input) { let master = []; input.forEach(row => { row.forEach(cell => { if (!master.includes(cell)) {
    master.push(cell);
} }); }); orderByAscending(master, m => m); return master; }
const activeSuffix = " (active)";
const inactiveSuffix = " (inactive)";
export function removeActiveInActiveSuffix(name) { if (name.endsWith(activeSuffix)) {
    return name.slice(0, name.length - activeSuffix.length);
}
else if (name.endsWith(inactiveSuffix)) {
    return name.slice(0, name.length - inactiveSuffix.length);
} return name; }
export function woodDetailAsString(input) { if (!input) {
    return "";
} let strs = []; if (input.materialName)
    strs.push(`material: ${input.materialName}`); if (input.cut)
    strs.push(input.cut); if (input.matching)
    strs.push(input.matching); if (input.matchingMethod)
    strs.push(input.matchingMethod); if (input.ply)
    strs.push(input.ply); if (input.finish)
    strs.push(input.finish); if (input.swatchName)
    strs.push(`swatchName: ${input.swatchName}`); if (input.proofFile)
    strs.push(`(proof file included)`); return strs.join(", "); }
export function prepsAsString(input) { const preps = input || {}; const keys = Object.keys(preps); const strs = []; console.log("prepsAsString", input); const locs = getSpecialtyHingePrepLocation(preps); if (locs) {
    strs.push(`Specialty Hinge Prep at ${locs.display}`);
} let unequalPair = null; let mergeActiveInactive = {}; for (let k of keys) {
    const obj = preps[k];
    if (obj.type === "custom") {
        const name = "Custom " + obj.productName;
        const frameSide = obj.frameSide;
        if (frameSide) {
            const obj = mergeActiveInactive[name] || [];
            obj.push(frameSide);
            mergeActiveInactive[name] = obj;
            continue;
        }
        strs.push(name);
        continue;
    }
    if (obj.type === "standard") {
        const name = removeActiveInActiveSuffix(k);
        const frameSide = obj.frameSide;
        if (frameSide) {
            const obj = mergeActiveInactive[name] || [];
            obj.push(frameSide);
            mergeActiveInactive[name] = obj;
            continue;
        }
        strs.push(k);
        continue;
    }
    if (obj.type === "frameAnchors") {
        console.log(obj);
        strs.push((obj.name || "Anchors") + " x " + obj.qty);
        continue;
    }
    if (obj.type === "customOffsets") {
        strs.push("Custom Locations");
        continue;
    }
    if (obj.type === "unequalPairDoorSizes") {
        unequalPair = `Unequal Pair (active=${obj.activeDoorWidth}, ${obj.inactiveDoorWidth})`;
        continue;
    }
} for (let k in mergeActiveInactive) {
    const obj = mergeActiveInactive[k];
    if (obj.length === 1) {
        strs.push(k + " (" + obj[0] + ")");
    }
    else {
        strs.push(k + " (active, inactive)");
    }
} if (unequalPair) {
    strs.unshift(unequalPair);
} if (strs.length === 0) {
    return "BLANK";
} return strs.join(", "); }
